const angular = require("angular");
angular.module("readCloudWebConsole").service("SelectedBookListService", SelectedBookListService);

/*@ngInject*/
function SelectedBookListService() {
  var SelectedBookListService = {};

  return SelectedBookListService;
}
